import '../styles/PageGlobal.css';
import './DevisDetailsEditPage.css';
import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DevisService } from '../services/DevisService.js';
import { AdresseService } from '../services/AdresseService.js';

export default function DevisDetailsEditPage() {
  const { devis_id } = useParams();
  const navigate = useNavigate();
  
  const [devis, setDevis] = useState(null);
  const [lines, setLines] = useState([]);
  const [adresses, setAdresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDevis = useCallback(async () => {
    const devisService = new DevisService();
    const adresseService = new AdresseService();
    setLoading(true);
    try {
      const data = await devisService.getDevisById(devis_id);
      
      setDevis(data);
      setLines(data.lines || []);
      
      const allAdresses = await adresseService.getAllAdresses();
      setAdresses(allAdresses);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [devis_id]);

  useEffect(() => { fetchDevis(); }, [fetchDevis]);

  const handleChangeLineField = (id, field, value) => {
    setLines(lines.map(l => {
      if (l.id === id) {
        return { ...l, [field]: value };
      }
      return l;
    }));
  };

  const handleDeleteLine = (id) => {
    if (window.confirm("Supprimer cette ligne du devis ?")) {
      setLines(lines.filter(l => l.id !== id));
    }
  };

  const handleDevisChange = (field, value) => {
    setDevis(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    const service = new DevisService();
    setLoading(true);
    try {
      const payload = {
        id: devis.id,
        clientId: devis.clientId,
        status: devis.status,
        adresseLivraisonId: devis.adresseLivraisonId,
        
        lines: lines.map(l => ({
          id: l.id,
          devisId: devis.id,
          reference: l.reference,
          refFabricant: l.refFabricant,
          productId: l.productId,
          quantity: l.quantity
        }))
      };
      await service.updateDevis(devis_id, payload);
      alert("Devis sauvegardé avec succès !");
      await fetchDevis();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  

  if (loading) return <div className="devis-status devis-status-loading">Chargement…</div>;
  if (error) return <div className="devis-status devis-status-error">{error}</div>;
  if (!devis) return <div className="devis-status devis-status-error">Devis non trouvé</div>;

  const isClientImmutable = devis.status !== 'DRAFT';

  return (
    <div className="containerMain devis-edit-container">
      <div className="devis-edit-header">
        <h1>Édition du Devis #{devis.id}</h1>
      </div>

      <div className="devis-main-fields" style={{ display: 'flex', gap: '20px', marginBottom: '30px', flexWrap: 'wrap', padding: '15px', background: '#f9f9f9', borderRadius: '8px' }}>
        <div className="devis-edit-row" style={{ flex: 1, minWidth: '200px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Client ID {isClientImmutable && '(non modifiable)'}
          </label>
          <input 
            type="number" 
            value={devis.clientId || ''} 
            onChange={(e) => handleDevisChange('clientId', Number(e.target.value))}
            disabled={isClientImmutable}
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', backgroundColor: isClientImmutable ? '#e9e9e9' : 'white' }}
          />
        </div>

        <div className="devis-edit-row" style={{ flex: 2, minWidth: '300px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Adresse de Livraison</label>
          <select 
            value={devis.adresseLivraisonId || ''}
            onChange={(e) => handleDevisChange('adresseLivraisonId', e.target.value ? Number(e.target.value) : null)}
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          >
            <option value="">-- Sélectionner une adresse --</option>
            {adresses.map(adresse => (
              <option key={adresse.id} value={adresse.id}>
                {adresse.adresse1}{adresse.adresse2 ? `, ${adresse.adresse2}` : ''} - {adresse.codePostal} {adresse.ville}
              </option>
            ))}
          </select>
        </div>

        <div className="devis-edit-row" style={{ flex: 1, minWidth: '200px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Statut</label>
          <select 
            value={devis.status || 'DRAFT'} 
            onChange={(e) => handleDevisChange('status', e.target.value)}
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          >
            <option value="DRAFT">DRAFT (Brouillon)</option>
           
            <option value="CLOSED">CLOSED (Fermé)</option>
          </select>
        </div>
      </div>

      <h2 style={{ marginTop: '30px', marginBottom: '15px' }}>Lignes du Devis</h2>
      <div className="devis-table-wrapper">
        <table className="devis-table">
          <thead>
            <tr>
              <th>Référence</th>
              <th>Ref. Fabricant</th>
              <th>Product ID</th>
              <th>Quantité</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {lines.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                  Aucune ligne dans ce devis.
                </td>
              </tr>
            ) : (
              lines.map(line => (
                <tr key={line.id}>
                  <td>
                    <input type="text" value={line.reference || ''} onChange={(e) => handleChangeLineField(line.id, 'reference', e.target.value)} style={{ width: '100px', padding: '4px' }} />
                  </td>
                  <td>
                    <input type="text" value={line.refFabricant || ''} onChange={(e) => handleChangeLineField(line.id, 'refFabricant', e.target.value)} style={{ width: '120px', padding: '4px' }} />
                  </td>
                  <td>
                    <input type="number" value={line.productId || ''} onChange={(e) => handleChangeLineField(line.id, 'productId', Number(e.target.value))} style={{ width: '80px', padding: '4px' }} />
                  </td>
                  <td>
                    <input type="number" min="1" value={line.quantity || 1} onChange={(e) => handleChangeLineField(line.id, 'quantity', Number(e.target.value))} style={{ width: '60px', padding: '4px' }} />
                  </td>
                  <td>
                    <button className="devis-btn devis-btn-red" onClick={() => handleDeleteLine(line.id)}>Suppr.</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
        <button className="devis-btn devis-btn-success" onClick={handleSave} disabled={loading}>
          {loading ? '...' : 'Sauvegarder'}
        </button>
       
        <button className="devis-btn devis-btn-grey" onClick={() => navigate("/devis_list")}>
          Annuler
        </button>
      </div>
    </div>
  );
}